import { IUserName } from 'PassportKnmPackage/MainModule/interfaces/IUserName';

import { IKnmFormAttachment } from './IKnmFormAttachment';
import { IKnmDictionaryOpenData } from './IKnmDictionaryOpenData';
import { ISubjectNotification } from './ISubjectNotification';
import { IEpguNotification } from './IEpguNotification';
import { IErpObjectResult } from './IErpObjectResult';
import { IErpObjectChecklist } from './IErpObjectChecklist';

export const ItAccreditationResponseOrgStatusDictionary = {
  ACTIVE: 'Действует',
  CANCELED: 'Аннулирована',
  ABSENT: 'Отсутствует',
  UNKNOWN: 'Неизвестный',
};

export enum ItAccreditationResponseOrgStatusEnum {
  ACTIVE = 'CANCELED',
  CANCELED = 'CANCELED',
  ABSENT = 'ABSENT',
}

export interface IInspectionErknmOrganization {
  act?: {
    numberAct?: string;
    creationActDateTime?: string;
    holdingDateTime?: string;
    durationDays?: string;
    durationHours?: string;
    isViolationResolved?: boolean;
    isViolationResolvedNote?: string;
    noteInvalidate?: string;
    canceledReason?: string;
  };
  inn?: string;
  ogrn?: string;
  organizationName?: string;
  isIndividualEntrepreneur?: boolean;
  isLegalEntity?: boolean;
  isSmallEnterprise?: boolean;
  okveds?: {
    name?: string;
  }[];
  isSonko?: boolean;
  isPresentInItRegistry?: boolean;
  itAccreditationResponse: {
    dateChange?: string;
    dateDecisionAccreditation?: string;
    dateRecord?: string;
    fullNameOrganization?: string;
    informationAboutChanges?: string;
    inn?: string;
    numberDecisionAccreditation?: string;
    organizationStatus?: ItAccreditationResponseOrgStatusEnum;
    registryNumber?: string;
    requestId?: string;
    requestStatus?: string;
  };
  mspCode?: string;
  subjectType?: string;
  country?: string;
  snils?: string;
  document?: string;
  locationAddress?: string;
  workAddress?: string;
  factualAddress?: string;
  rafpNza?: string;
  resultDecisions?: {
    kindDecision?: {
      name?: string;
    };
    noteLawsuits?: IKnmDictionaryOpenData[];
    numberDecision?: string;
    dateDecision?: string;
    fioSigner?: string;
    titleSigner?: IKnmDictionaryOpenData;
    inspectors?: { fullName?: string; position?: IKnmDictionaryOpenData }[];
    isProsecution?: boolean;
    responsibleEntities?: {
      type?: { name?: string };
      inn?: string;
      ogrn?: string;
      organizationName?: string;
      responsibilityType?: { name?: string };
      punishmentAmount?: string;
      punishmentAmountMeasure?: string;
      structuresNPA?: { value?: string }[];
    }[];
  }[];
}

// Нарушение из акта ПМ. Бек уплощает многоуровневую структуру ЗЧ,
// поэтому title тут это наименование НПА, а не формулировка требования.
export interface IPmActViolation {
  number?: string;
  acceptanceDate?: string;
  title?: string;
  structuralUnit?: {
    title?: string;
  };
}

export interface IPmAct {
  numberAct?: string;
  creationActDateTime?: string;
  holdingDateTime?: string;
  durationDays?: number;
  durationHours?: number;
  violations?: IPmActViolation[];
}

export interface IPmResultDecision {
  kindDecision?: {
    name?: string;
  };
  numberDecision?: string;
  fioSigner?: string;
  titleSigner?: IKnmDictionaryOpenData;
}

export interface IKnmPreview {
  id: number;
  annualId?: null;
  knoFullName?: string;
  approve?: {
    approveDocs?: Array<{
      name?: string;
      number?: string;
      date?: string; //  string; //  number[];
    }>;
    approved?: boolean;
    carryoutEvents?: Array<{
      datePublish?: null;
      endDate?: string; // string; //  number[];
      eventsText?: string;
      main?: boolean;
      numId?: null;
      startDate?: string; // string; //  number[];
    }>;
    datePublish?: null;
    decisionPlace?: null;
    decisionSignerName?: null;
    decisionSignerTitle?: null;
    durationDay?: number;
    durationHours?: number;
    endDate?: string; //  number[];
    extDurationDay?: null;
    extDurationHours?: null;
    inspectionTarget?: string;
    impossibleConductionReason?: string;
    reasons?: Array<{
      approveRequired?: boolean;
      code?: string;
      date?: string; //  number[];
      datePublish?: null;
      main?: boolean;
      name?: string;
      text?: string;
      type?: null;
    }>;
    startDate?: string; //  number[];
    startDateAsMonth?: boolean;
  };
  authorities?: Array<{
    frguOrgId?: string;
    frguOrgName?: string;
    frguOrgOgrn?: string;
    jointly?: string;
    authorityServ?: Array<{
      frguServId?: string;
      frguServName?: string;
    }>;
  }>;
  classification?: {
    carryoutTypeCode?: string;
    carryoutTypeName?: string;
    datePublish?: null;
    noticeDate?: string; // string; //  number[];
    noticeTypeCode?: string;
    noticeTypeName?: string;
    riskCode?: string;
    riskName?: string;
    spendingDescription?: null;
    spendingTypeCode?: null;
    spendingTypeName?: null;
    subjectTypeCode?: string;
    subjectTypeName?: string;
    supervisionCode?: string;
    supervisionName?: string;
  };
  created?: string; // string; //  number[];
  datePublish?: null;
  domainId?: null;
  domainName?: null;
  erpCreateDate?: string; // string; //  number[];
  erpId: string;
  firstDayStartDate?: null;
  fzCode?: null;
  fzName?: string;
  auditedPersonAuthority?: Array<string>;
  groupId?: null;
  legalBases?: Array<{
    atrDate?: string; //  number[];
    atrI?: null;
    atrII?: null;
    atrIII?: null;
    atrIV?: null;
    atrNumber?: null;
    atrV?: null;
    datePublish?: null;
    documentId?: null;
    documentName?: string;
    numId?: null;
    typePointingCode?: null;
    typePointingName?: null;
  }>;
  reasonsErvk?: {
    reason: {
      ervkUuid: string;
      title: string;
      programNumber: string;
      programAttachment?: IKnmFormAttachment[] | null;
      date: string;
      type: {
        name: string;
        lastConductedKnmDateRequired: boolean;
      };
      requirementDetails?: string;
      dateRequirement?: string;
      assignmentNumber?: string;
      assignmentDate?: string;
      lastConductedKnmDate?: string;
    };
    riskIndicators?: {
      riskIndicator?: IKnmDictionaryOpenData;
      indicatorRiskAuto?: boolean;
    }[];
  }[];
  monthId?: null;
  name?: null;
  objects?: Array<{
    address?: string;
    addressTypeCode?: string;
    //
    isAddressHazard?: boolean;
    notInFIAS?: boolean;
    manualAddress?: string;
    fiasRegion?: string | { name: string };
    //
    addressTypeName?: string;
    chlistHeaders?: Array<IErpObjectChecklist>;
    datePublish?: null;
    hasResult?: boolean;
    main?: boolean;
    numId?: null;
    result?: IErpObjectResult;
    riskCode?: null;
    riskName?: null;
    supervisions: Array<{
      name?: string;
    }>;
    typeCode?: string;
    typeName?: string;
  }>;
  objectsErvk?: Array<{
    address?: string;
    notInFIAS?: boolean;
    manualAddress?: string;
    region?: string;
    fiasRegion?: string | { name: string };
    objectType?: IKnmDictionaryOpenData;
    objectKind?: IKnmDictionaryOpenData;
    objectSubKind?: IKnmDictionaryOpenData;
    riskCategory?: IKnmDictionaryOpenData;
    isAddressHazard?: boolean;
    chlistHeaders?: Array<IErpObjectChecklist>;
    result?: IErpObjectResult;
    supervisions: Array<{
      name?: string;
    }>;
  }>;
  okato?: {
    datePublish?: null;
    federalDistrict?: string;
    okatoKod1?: string;
    okatoKod2?: string;
    okatoKod3?: string;
    okatoName?: string;
    okatoRazdel?: number;
    okatoTer?: string;
  };
  prosecId?: null;
  prosecName?: string;
  requirements?: Array<{
    name?: string;
    knoName?: null | string;
    documents?: Array<{
      article?: string;
      date?: string; //  number[];
      index?: number;
      name?: string;
      number?: string;
      paragraph?: string;
      part?: string;
      props?: string;
    }>;
  }>;
  publish: boolean;
  startDate?: string; // string; //  number[];
  stopDate?: string; // string; //  number[];
  startMonth?: null;
  status?: string;
  subject?: {
    datePublish?: null;
    establishDate?: null;
    inn?: string;
    lastInspectionDate?: null;
    licenceReason?: null;
    licenceReasonDateI?: null;
    licenceReasonDateII?: null;
    ogrn?: string;
    orgName?: string;
    registrationDate?: string; //  number[];
    resident?: boolean;
    typeCode?: string;
    typeName?: string;
  };
  typeCode?: string;
  typeName?: string;
  version?: string; // KnmVersionsEnum
  signed?: boolean | null;
  noticeMethod?: {
    name?: string;
  };
  noticeDate?: string; // number[]
  links?: {
    guid?: string;
    erpId?: string;
    dateCreate?: string;
  }[];
  subjectNotifications?: ISubjectNotification[];
  epguNotifications?: IEpguNotification[];
  inspectionErknm?: {
    dataContent?: string;
    kindKnm?: IKnmDictionaryOpenData;
    abrogation?: {
      comment: string;
      reasonId: number;
      link?: {
        erpId: string;
        id: number;
      };
    };
    publicAbrogation?: {
      comment: string;
      reason: string;
      linkedInspectionId?: string;
      linkedInspectionErpId?: number;
    };
    decision?: {
      dateTimeDecision?: string; // string; //  number[];
      fioSigner?: string;
      numberDecision?: string;
      placeDecision?: string;
      titleSigner?: IKnmDictionaryOpenData;
      decisionDisabled?: boolean;
      disabledDecisionMessage?: string;
      notInFIAS?: boolean;
      manualAddress?: string;
      region?: string;
    };
    reasons?: {
      reason: {
        ervkUuid: string;
        title: string;
        programNumber: string;
        programAttachment?: IKnmFormAttachment[] | null;
        date: string; // string; //  number[];
        type: {
          name: string;
          lastConductedKnmDateRequired: boolean;
        };
        requirementDetails?: string;
        dateRequirement?: string;
        assignmentNumber?: string;
        assignmentDate?: string;
        lastConductedKnmDate?: string;
      };
      riskIndicators?: {
        riskIndicator?: IKnmDictionaryOpenData;
        indicatorRiskAuto?: boolean;
      }[];
    }[];
    approve?: {
      approveRequired: string; // ApproveRequiredTypesEnum
      approveRequiredTitle: string;
      approved?: string;
      dateRejectReason?: string;
      numberDecision?: string;
      dateDecision?: string; // string; //  number[];
      fioSigner?: string;
      titleSigner?: string;
      rejectReasonType?: {
        name?: string;
      };
    };
    requirements?: {
      isObserved?: boolean;
      note?: string;
      requirement?: IKnmDictionaryOpenData;
    }[];
    requirementsNew?: {
      title: string;
      number: string;
      acceptanceDate: string; // string; //  number[];
      structuralUnit: {
        title: string;
      };
    }[];
    approveDocs?: {
      approveDoc?: IKnmDictionaryOpenData;
      dateCreate?: string; //  number[];
    }[];
    docTarget: {
      ervkControlKindDocTarget: {
        targetId: string | number | null;
        targetTitle: string;
        type: string;
      };
      file?: IKnmFormAttachment | null;
      specificRequirementAndClause?: string | null;
    }[];
    isChecklistsUsed?: boolean;
    checklists?: {
      checkList?: IKnmDictionaryOpenData;
      ervkCheckList?: {
        date: string;
        description: string;
        number: number;
        id: number;
      };
    }[];
    places?: {
      value: string;
      matchesObjectAddress?: boolean;
      notInFIAS?: boolean;
      manualAddress?: string;
      region?: string;
    }[];
    organizationDocuments?: {
      value: string;
    }[];
    isPresence?: boolean;
    rescheduling?: {
      comment?: string;
      initiationDate: string;
      newDirectDurationDays?: number;
      newDurationDays?: number;
      newDurationHours?: number;
      newEndDate: string;
      newStartDate: string;
      oldEndDate: string;
      oldStartDate: string;
    }[];
    isPresenceDelegateFullNames?: {
      value: string;
    }[];
    isSelection?: boolean;
    selection?: string;
    withVideo?: boolean;
    serviceDocument?: {
      description: string;
    };
    returnSelection?: boolean;
    knoOrganization?: IKnmDictionaryOpenData;
    kindControl?: IKnmDictionaryOpenData;
    organizations?: IInspectionErknmOrganization[];
    objects?: {
      cosId?: string;
      ervkNumber?: string;
      name?: string;
      address?: string;
      notInFIAS?: boolean;
      manualAddress?: string;
      region?: string;
      fiasRegion?: string | { name: string };
      objectType?: IKnmDictionaryOpenData;
      objectKind?: IKnmDictionaryOpenData;
      objectSubKind?: IKnmDictionaryOpenData;
      riskCategory?: IKnmDictionaryOpenData;
      dangerClass?: IKnmDictionaryOpenData;
      isAddressHazard?: boolean;
    }[];
    documentRequestDate?: string; // string; //  number[];
    documentResponseDate?: string; // string; //  number[];
    experts?: {
      title?: string;
      type?: {
        name: string;
      };
    }[];
    isHasCollaboratingOrganization?: boolean;
    collaboratingOrganizations?: {
      organization: IKnmDictionaryOpenData;
    }[];
    isRemote?: boolean;
    interactionCategory?: {
      id: number;
      name: string;
    };
    noteRemote?: string;
    events: {
      event?: IKnmDictionaryOpenData;
      interactionCategory?: {
        id: number;
        name: string;
      };
      startDate?: string; // string; //  number[];
      stopDate?: string; // string; //  number[];
      suspension?: {
        dateCreate?: string;
        startDate?: string;
        stopDate?: string;
        decisionDateTime?: string;
        decisionNumber?: string;
        decisionPlace?: string;
        manualAddress?: string;
        notInFIAS?: boolean;
        region?: string;
      }[];
      submittedDocuments: {
        description?: string | null;
        documentTitle: string;
        files?: IKnmFormAttachment[] | null;
        requestDateTime: string;
        status: {
          code: string;
          id: number;
          title: string;
          weight: number;
        };
        submissionDateTime?: string | null;
        submissionDeadline: string;
      }[];
    }[];
  };
  pmErknm: {
    warningContentCreatorPosition?: string;
    officialFullName?: string;
    rescheduling?: {
      comment?: string;
      initiationDate: string;
      newEndDate: string;
      newStartDate: string;
      oldEndDate: string;
      oldStartDate: string;
    }[];
    experts?: {
      title?: string;
      type?: {
        name: string;
      };
    }[];
    inspectors?: {
      fullName?: string;
      position?: {
        value: string;
      };
    }[];
    publicAbrogation?: {
      comment: string;
      reason: string;
      linkedInspectionId?: string;
      linkedInspectionErpId?: number;
    };
    docTarget: {
      ervkControlKindDocTarget: {
        targetId: string | number | null;
        targetTitle: string;
        type: string;
      };
      file?: IKnmFormAttachment | null;
      specificRequirementAndClause?: string | null;
    }[];
    fullName: string;
    position: string;
    signerPosition: IKnmDictionaryOpenData;
    subject: {
      isIndividualEntrepreneur?: boolean;
      isLegalEntity?: boolean;
      isSmallEnterprise?: boolean;
      inn?: string;
      ogrn?: string;
      organizationName?: string;
      okveds?: {
        name?: string;
      }[];
      isSonko?: boolean;
      isPresentInItRegistry?: boolean;
      itAccreditationResponse: {
        dateChange?: string;
        dateDecisionAccreditation?: string;
        dateRecord?: string;
        fullNameOrganization?: string;
        informationAboutChanges?: string;
        inn?: string;
        numberDecisionAccreditation?: string;
        organizationStatus?: ItAccreditationResponseOrgStatusEnum;
        registryNumber?: string;
        requestId?: string;
        requestStatus?: string;
      };
      mspCode?: string;
      subjectType?: string;
      country?: string;
      snils?: string;
      document?: string;
      locationAddress?: string;
      workAddress?: string;
      factualAddress?: string;
      rafpNza?: string;
      act?: IPmAct;
      // Решений может быть несколько, даже когда предписание одно.
      resultDecisions?: IPmResultDecision[];
    };
    objects?: {
      cosId?: string;
      ervkNumber?: string;
      name?: string;
      fiasRegion?: string | { name: string };
      address?: string;
      notInFIAS?: boolean;
      manualAddress?: string;
      region?: string;
      objectType?: IKnmDictionaryOpenData;
      objectKind?: IKnmDictionaryOpenData;
      objectSubKind?: IKnmDictionaryOpenData;
      riskCategory?: IKnmDictionaryOpenData;
      dangerClass?: IKnmDictionaryOpenData;
    }[];
    isHasCollaboratingOrganization?: boolean;
    collaboratingOrganizations?: {
      organization: IKnmDictionaryOpenData;
    }[];
    supervisionType?: IKnmDictionaryOpenData;
    knoOrganization?: IKnmDictionaryOpenData;
    pmType?: IKnmDictionaryOpenData;
    pmForm?: {
      id: number;
      title: string;
    };
    location?: string;
    notInFIAS?: boolean;
    isUnableToRefuse?: boolean;
    manualAddress?: string;
    matchesObjectAddress?: boolean;
    region?: string;
    fiasRegion?: string;
    noteWarning?: string;
    reasons?: {
      reason: {
        ervkUuid: string;
        title: string;
        programNumber: string;
        date: string; //  number[];
        type: {
          name: string;
          title?: string;
        };
      };
      order: {
        date: string;
        number: string;
        guarantors: IUserName[];
      };
      riskIndicators?: {
        riskIndicator?: IKnmDictionaryOpenData;
        indicatorRiskAuto?: boolean;
      }[];
    }[];
    events: Array<{
      event?: IKnmDictionaryOpenData;
      interactionCategory?: {
        id: number;
        name: string;
      };
      startDate?: string;
      stopDate?: string;
      periodExtension?: {
        giud?: string;
        dateCreate?: string;
        decisionDateTime?: string;
        decisionNumber?: string;
        amountDays?: number;
      };
      suspension?: Array<{
        giud?: string;
        eventTitle?: string;
        dateCreate?: string;
        startDate?: string;
        stopDate?: string;
        decisionDateTime?: string;
        decisionNumber?: string;
        decisionPlace?: string;
      }>;
    }>;
    requirements?: {
      title: string;
      number: string;
      acceptanceDate: string; // string; //  number[];
      structuralUnit: {
        title: string;
        mandatoryRequirements: {
          title: string;
        }[];
      };
    }[];
    approveDocs?: {
      approveDoc?: IKnmDictionaryOpenData;
      dateCreate?: string;
    }[];
    isHasNotification?: boolean;
    dateOfNotification?: string; //  number[];
    isRejectSubject?: boolean;
    dateRejectSubject?: string; //  number[];
    resultOfInspection?: string;
    pmRejects?: {
      date?: string;
      pmCanceledReason?: {
        name?: string;
      };
    }[];
    interactionCategory?: {
      id: number;
      name: string;
    };
    videoCallInfo?: {
      dateTime?: string;
      guid?: string;
      instruction?: string;
      link?: string;
    }[];

    preventiveVisitSystemSignatureUsed: boolean;
    preventiveVisitSystemSignatureTitle: string | null;
    preventiveVisitSystemSignatureMnemonic: string | null;
    preventiveVisitSystemSignatureDateTime: string | null;

    warningIssuingSystemSignatureUsed: boolean;
    warningIssuingSystemSignatureTitle: string | null;
    warningIssuingSystemSignatureMnemonic: string | null;
    warningIssuingSystemSignatureDateTime: string | null;
    takenMeasures?: {
      guid?: string;
      value?: string;
    }[];
  };
  transferred?: boolean;
  transferringAuthorities?: {
    uuid: string;
    title: string;
    shortTitle: string;
  }[];
  massCancel?: {
    reason?: string;
    cancelled?: string;
    reasonFileName?: string;
  };
}
